import React from 'react';
import { DCBUnsubscribeCountry as DCBUnsubscribeCountryScreen } from '@features/dcb-unsubscribe-country';

export const DCBUnsubscribeCountry = (props: any) => <DCBUnsubscribeCountryScreen {...props} />;
